import React from 'react';
import { observer } from 'mobx-react-lite';

import { Card } from 'app/components/common/Card';
import { CampaignStatusSelect } from 'app/components/CampaignStatusSelect';
import { useModelWithArguments } from 'app/hooks/useViewModel';
import { CampaignViewModel } from 'app/viewModels/components/CampaignViewModel';
import { CardProperty } from 'app/components/common/CardProperty';
import { CampaignUpdateStatusModal } from 'app/components/CampaignUpdateStatusModal';
import { Routes } from 'src/types/routes';
import { formateDate } from 'app/utils/formateDate';

type Props = {
    campaignId: string,
};

export const UserInnerCard = observer(({ campaignId }: Props) => {
    const model = useModelWithArguments(CampaignViewModel, campaignId);
    const {
        id,
        status,
        createAt,
        slug,
        openUpdateStatusModal,
    } = model;

    const formatedCreateAt = createAt ? formateDate(createAt) : '-';
    const campaignSlug = slug || '-';

    return (
        <Card isActiveHeader={false} to={Routes.Dashboard.CampaignInnerPage(id || campaignId)}>
            <CardProperty title="Plan">
                <span className="p1-regular dark-violet">{campaignSlug}</span>
            </CardProperty>

            <CardProperty title="Date">
                <span className="p1-regular dark-violet">{formatedCreateAt}</span>
            </CardProperty>

            {status && (
                <CardProperty title="Status">
                    <CampaignStatusSelect
                        currentStatus={status}
                        onSelectStatus={openUpdateStatusModal}
                    />
                </CardProperty>
            )}

            <CampaignUpdateStatusModal model={model} />
        </Card>
    );
});

